"use strict";

var _classCallCheck = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Represents an Item within LinkedList.
 * An item holds a value and the links to other LinkedListItem's
 * LinkedListItem's can only be attached behind.
 * Theirfor, to add one before, before has to add one behind.
 */

var LinkedListItem = /*#__PURE__*/function () {
  /**
   * @param value Value to be held
   * @param unlinkCleanup Function to run on unlink() call. Usually used by LinkedList to fix first and last pointers and reduce length.
   */
  function LinkedListItem(value,
  /**
   *
   */
  unlinkCleanup) {
    _classCallCheck(this, LinkedListItem);

    this.value = value;
    this.unlinkCleanup = unlinkCleanup;
  }
  /**
   * This will link given LinkListItem behind this item.
   * If there's already a LinkedListItem linked behind, it will be relinked accordingly
   * @param item LinkListItem to be inserted behind this one
   */


  _createClass(LinkedListItem, [{
    key: "insertBehind",
    value: function insertBehind(item) {
      item.insertBefore(this);

      if (this.behind) {
        var itemChainEnd = item;

        while (itemChainEnd.behind) {
          itemChainEnd = itemChainEnd.behind;
        }

        this.behind.insertBefore(itemChainEnd);
        itemChainEnd.insertBehind(this.behind);
      }

      this.behind = item;
    }
    /**
     * Unlinks this LinkedListItem and calls unlinkCleanup
     * @param unchain If true, additionally removes the reference to the item before and behind
     * @see LinkedListItem#unlinkCleanup
     */

  }, {
    key: "unlink",
    value: function unlink() {
      var unchain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.before) this.before.behind = this.behind;

      if (this.behind) {
        this.behind.before = this.before;
      }

      if (this.unlinkCleanup) {
        this.unlinkCleanup(this);
      }

      this.unlinkCleanup = undefined;

      if (unchain) {
        this.before = this.behind = undefined;
      }
    }
    /**
     * Item given will be inserted before this item.
     * unlinkCleanup will be copied if neccessary.
     * This function is protected, because LinkedListItem's can only be attached behind.
     *
     * @param before
     * @see insertBehind
     */

  }, {
    key: "insertBefore",
    value: function insertBefore(before) {
      this.before = before;

      if (!this.unlinkCleanup) {
        this.unlinkCleanup = before.unlinkCleanup;
      }
    }
  }]);

  return LinkedListItem;
}();

exports.LinkedListItem = LinkedListItem;